<template lang="pug">
section#event-page.section.page-section.top-section
  spinner(v-if="settings.loading")
  div(v-else)
    .event-header(:style="`background-image:url(${backgroundUrl})`")
      .container.mobile-padding(v-parallax="-0.2")
        h1.is-size-1-desktop.is-size-3-touch {{ event.title }}
        p.collection-desc
          .organization.is-size-4-desktop.is-size-5-touch(v-if="isProject") {{ account.organization }}
          event-date.is-size-4-desktop.is-size-5-touch(
            v-else
            format="dddd, MMMM Do"
            :limit="1"
            :value="event"
          )
        a.button.is-primary(
          v-if="canRegister"
          href="#"
          v-scroll-to="{ el: '#event-form', offset: -96 }"
        )
          span Sign Up
          b-icon(icon="arrow-right")

    section.section.page-section
      .event-body.container
        .columns
          .column.is-two-thirds
            .content.mobile-margin(v-if="event.long_desc")
              h3.is-size-3-desktop.is-size-4-touch.short-description {{ event.short_desc }}
              p.is-size-5(
                v-if="event.long_desc"
                v-html="compiledLongDesc"
              )
              video-player(
                v-if="event._embedded.video.id"
                :video="event._embedded.video"
              )
            //- .event-contact.content.mobile-margin(v-if="event._embedded.contact.id")
            //-   p Questions about this event?
            //-   .media
            //-     .media-left(v-if="event._embedded.contact.profile_image")
            //-       cl-img.avatar(
            //-         :cl-id="event._embedded.contact.profile_image.cl_id"
            //-         :transform="{ width: 120, height: 120, crop: 'thumb' }"
            //-       )
            //-     .media-content
            //-       h3.is-size-4 {{ event._embedded.contact.name }}
            //-       .level.is-mobile
            //-         .level-left
            //-           .level-item(v-if="event._embedded.contact.email")
            //-             .list-item-content
            //-               a(:href="`mailto:${event._embedded.contact.email}?subject=Question about ${event.title}`")
            //-                 b-icon(icon="email-outline" size="is-small")
            //-                 span {{ isMobile ? 'Email' : event._embedded.contact.email }}
            //-           .level-item(v-if="event._embedded.contact.phone_number")
            //-             a(:href="`tel:${event._embedded.contact.phone_number}`")
            //-               b-icon(icon="cellphone" size="is-small")
            //-               span {{ isMobile ? 'Call' : event._embedded.contact.phone_number }}
            about-event.is-hidden-desktop.mobile-margin(v-if="isMobile")
            .event-related(v-if="!isProject && !canRegister && event._embedded.related && event._embedded.related.length > 0")
              .columns.is-multiline
                .column.is-half(
                  v-for="related in event._embedded.related"
                  :key="related.id"
                )
                  event-list-item(
                    :limit="2"
                    :value="related"
                  )

            event-form.mobile-margin(v-if="canRegister")

          .column.is-one-third.is-hidden-touch
            about-event(
              v-if="!isMobile"
              v-sticky
              sticky-offset="{ top: 96, bottom: 12 }"
            )
        .events(v-if="events.length > 0")
          .mobile-margin
            h4.is-size-4 Events
          .columns.is-multiline
            .column.is-one-quarter(
              v-for="event in events"
              :key="event.id"
            )
              event-list-item(
                :value="event"
                hoverable
              )
        .episodes(v-if="episodes.length > 0")
          .mobile-margin
            h4.is-size-4 Sermons
          .columns.is-multiline
            .column.is-one-quarter(
              v-for="episode in episodes"
              :key="episode.id"
            )
              episode-list-item(
                :value="episode"
                hoverable
              )
</template>

<script>
import _ from 'lodash';
import cloudinary from 'cloudinary-core';
import marked from 'marked';
import moment from 'moment';
import { mapGetters } from 'vuex';
import AboutAccount from '@/components/accounts/AboutAccount.vue';
import AboutEvent from '@/components/events/AboutEvent.vue';
import EpisodeListItem from '@/components/episodes/EpisodeListItem.vue';
import EventDate from '@/components/events/EventDate.vue';
import EventForm from '@/components/events/EventForm.vue';
import EventListItem from '@/components/events/EventListItem.vue';
import ReadMore from '@/components/ReadMore.vue';
import Spinner from '@/components/Spinner.vue';
import VideoPlayer from '@/components/VideoPlayer.vue';
import * as actionTypes from '@/store/types/actions';
import * as getterTypes from '@/store/types/getters';
import * as mutationTypes from '@/store/types/mutations';

export default {
  name: 'event',
  components: {
    AboutAccount,
    AboutEvent,
    EpisodeListItem,
    EventDate,
    EventListItem,
    EventForm,
    ReadMore,
    Spinner,
    VideoPlayer,
  },
  computed: {
    ...mapGetters({
      account: getterTypes.GET_ACCOUNT,
      episodes: getterTypes.GET_EPISODES,
      event: getterTypes.GET_EVENT,
      events: getterTypes.GET_EVENTS,
    }),
    backgroundUrl() {
      if (!this.event._embedded.artwork) return null;
      let opts = {};
      if (this.isMobile) {
        opts = {
          width: 600,
          height: 600,
          effect: 'blur:1000',
          quality: 'auto',
          fetch_format: 'auto',
          crop: 'thumb',
          opacity: 60,
          format: 'png',
        };
      } else {
        opts = {
          width: 1200,
          height: 700,
          effect: 'blur:700',
          quality: 'auto',
          fetch_format: 'auto',
          crop: 'fill',
          opacity: 50,
          format: 'png',
        };
      }
      return this.cloudinary.url(this.event._embedded.artwork.cl_id, opts);
    },
    canRegister() {
      return this.event.registration_required && this.event._embedded.form.id !== undefined;
    },
    compiledLongDesc() {
      return marked(this.event.long_desc);
    },
    deadlinePassed() {
      if (!this.event.registration_deadline) return false;
      return moment().isAfter(this.event.registration_deadline, 'day');
    },
    discounted() {
      return this.participants.length > 1 && this.selectedPackage.discount_cost > 0;
    },
    episodesQuery() {
      const ids = _.map(this.event._embedded.collections, 'id');
      const today = moment().format('YYYY-MM-DD');
      const from = this.pagination.per * (this.pagination.page - 1);
      const payload = {
        from,
        size: this.pagination.per,
        sort: [
          { pub_date: 'asc' },
        ],
        query: {
          bool: {
            must: [
              { terms: { collection_ids: ids } },
              { match: { is_published: true } },
              { range: { pub_date: { lte: today } } },
            ],
          },
        },
      };
      return payload;
    },
    eventsQuery() {
      const ids = _.map(this.event._embedded.events, 'id');
      const today = moment().format('YYYY-MM-DD');
      const payload = {
        size: 8,
        sort: [
          { end_date: 'asc' },
        ],
        query: {
          bool: {
            must: [
              { terms: { id: ids } },
              { match: { is_published: true } },
              { range: { pub_date: { lte: today } } },
            ],
          },
        },
      };
      return payload;
    },
    isMobile() {
      return window.innerWidth <= 769;
    },
    isProject() {
      return this.event.type === 'project';
    },
    ministryLabel() {
      return this.ministries.length === 1 ? 'Ministry' : 'Ministries';
    },
    morePages() {
      if (this.pagination.total === 0) return false;
      return Math.ceil(this.pagination.total / this.pagination.per) > this.pagination.page;
    },
  },
  created() {
    this.init();
  },
  data() {
    return {
      bottom: false,
      cloudinary: null,
      ministries: [],
      pagination: {
        page: 1,
        per: 12,
        total: 0,
      },
      settings: {
        loading: false,
      },
    };
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollHandler);
  },
  methods: {
    async getEpisodesPage(page, opts) {
      this.pagination.page = page;
      const payload = Object.assign({}, (opts || {}), this.episodesQuery);
      const response = await this.$store.dispatch(actionTypes.DO_GET_EPISODES, payload);
      this.pagination.total = response.hits.total;
    },
    async getEvents() {
      await this.$store.dispatch(actionTypes.DO_GET_EVENTS, this.eventsQuery);
    },
    async init() {
      this.settings.loading = true;
      this.$store.commit(mutationTypes.SET_EPISODES, []);
      this.$store.commit(mutationTypes.SET_EVENTS, []);
      this.$store.commit(mutationTypes.SET_EVENT_REGISTRATION, {});
      this.$store.commit(mutationTypes.SET_EVENT_REGISTRATION_PARTICIPANTS, [[]]);
      this.$store.commit(mutationTypes.SET_EVENT_REGISTRATION_FIELDS, []);
      this.cloudinary = cloudinary.Cloudinary.new({
        cloud_name: process.env.VUE_APP_CLOUDINARY_CLOUD_NAME,
      });
      await this.$store.dispatch(actionTypes.DO_GET_EVENT, {
        id: this.$route.params.id,
        related_count: 4,
        zoom: 'artwork,collections,contact,form,events,instances,location,ministries,packages,related,video',
      });
      if (this.event.type === 'project') {
        const { collections, events } = this.event._embedded;
        if (collections && collections.length > 0) {
          await this.getEpisodesPage(1);
        }
        if (events && events.length > 0) {
          await this.getEvents();
        }
      }
      this.settings.loading = false;
    },
    scrollHandler() {
      const y = window.scrollY;
      const visible = document.documentElement.clientHeight;
      const pageHeight = document.documentElement.scrollHeight;
      const adjustedHeight = pageHeight - 300;
      const bottomOfPage = visible + y >= adjustedHeight;
      this.bottom = bottomOfPage || adjustedHeight < visible;
    },
  },
  mounted() {
    window.addEventListener('scroll', this.scrollHandler);
  },
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  watch: {
    bottom(val) {
      if (val && this.morePages) {
        this.getEpisodesPage(this.pagination.page + 1, { method: 'append' });
      }
    },
    $route(to, from) {
      if (to.params.id !== from.params.id) this.init();
    },
  },
};
</script>

<style lang="scss">
#event-page {
  .event-header {
    @include hero;
    .button {
      margin-top: 2rem;
      font-family: $heading-font;
    }
  }

  .event-body {
    .content {
      background-color: $white;
      padding: 1.5rem;
      &.mobile-margin {
        border-radius: 4px;
        box-shadow: 0 0 30px rgba(0,0,0,0.05);
      }
    }
    .video-wrapper {
      max-width: 100%;
      padding-bottom: 56.25%;
      position: relative;
    }
  }

  .event-contact {
    margin-top: 1.25rem;
    padding-top: 1.25rem;
    .media {
      align-items: center;
      .avatar {
        width: 60px;
        border-radius: 60px;
      }
      h3 {
        margin-bottom: 0.25rem;
      }
      a {
        color: $grey-dark;
        transition: 0.35s color ease-in-out;
        &:hover {
          color: $primary;
          text-decoration: underline;
        }
      }
      .level {
        .level-item {
          display: flex;
          align-items: center;
          .icon {
            margin-right: 0.25rem;
          }
        }
      }
    }
  }
}

@media (max-width: $tablet) {
  #event-page {
    .page-section {
      padding-top: 1.5rem;
    }
    .event-header {
      background-size: cover;
      background-attachment: inherit;
      .event-date {
        max-width: 260px;
        margin: 0 auto;
      }
    }
    #event-form {
      margin-top: 1.5rem;
    }
    .event-related {
      margin-top: 1.5rem;
      .columns {
        @include carousel;
      }
    }
  }
}
</style>

<style theme="cwo" lang="scss">
#event-page {
  .event-header {
    .organization {
      font-family: $heading-font;
      text-transform: uppercase;
    }
  }
  .event-body {
    h3.short-description {
      line-height: 140%;
    }
  }
  .button.is-primary, h1, h2, h3 {
    font-family: $body-font !important;
    font-weight: 700 !important;
  }
  .episodes, .events {
    h4 {
      margin-bottom: 1rem;
      text-transform: uppercase;
    }
  }
  .events {
    margin-top: 1rem;
    margin-bottom: 2.5rem;
  }
}
</style>
